
import { Options, mixins } from "vue-class-component";
import StoreReports from "../../service/StoreReports";
import UtilityOptions from "../../mixins/UtilityOptions";

interface IList {
  accountName: string;
  accountNature: string;
  totalCredit: number;
  totalDebit: number;
}

@Options({
  title: 'Trial Balance',
  components: {},
})

export default class TrialBalance extends mixins(UtilityOptions) {
  private lists: IList []  = [];
  private reportService;
  private resultTitle = "";
  private storeName = "";
  private productDialog = false;
  private loading = false;
  private home = { icon: "pi pi-home", to: "/" };
  private items = [
    { label: "Reports", to: "index" },
    { label: "Trial Balance", to: "trial-balance-report"  },
  ];

  private searchFilters = {
    id: "",
    date1: "",
    date2: "",
    filterType: "this_year",
    storeType: "all_stores",
    storeID: 0,
  };

  private brands:any = [];
  private sectors:any = [];
  private categories:any = [];
  private productTypes:any = [];

  private filterDates = [];
  private dialogTitle;
  private submitted = false;
  private filterBranch = [];

  created() {
    this.reportService = new StoreReports();
  }
  
  mounted() {
    this.storeList();
  }

  openDialog() {       
    this.submitted = false;
    this.dialogTitle = "Filter Report";
    this.productDialog = true;
  }

  storeList() {
    this.searchFilters.storeType = 'single_store';

    this.reportService.getFilterList().then((res) => {
      this.filterBranch = res.branches.map(b => ({
        ...b,
        id: Number(b.id)
      }));

      this.filterDates = res.datesList;

      this.searchFilters.storeID = Number(res.current_branch_id);

      this.loadList();
    });
  }
 
  // USED TO GET SEARCHED ASSOCIATE
  loadList() {
    this.loading = true;

    this.searchFilters.storeType = (this.searchFilters.storeID && this.searchFilters.storeID !== 0)
        ? 'single_store'
        : 'all_stores';

    this.reportService.trialBalance(this.searchFilters).then((res) => {
        const data = this.camelizeKeys(res);
        this.resultTitle = data.resultTitle;
        this.storeName = data.storeName;
        this.lists = data.record;
        this.loading = false;
      });
    this.productDialog = false;
  }

  get trialBalanceList() {
    return this.lists.map(e => {
      const d = e.totalDebit - e.totalCredit;
      return {
        ...e,
        totalDebit:  d > 0 ?  d : 0,
        totalCredit: d < 0 ? -d : 0,
      };
    });
  }

  get sumTotalDebit() {
    return this.trialBalanceList.reduce((t, e) => t + e.totalDebit, 0);
  }

  get sumTotalCredit() {
    return this.trialBalanceList.reduce((t, e) => t + e.totalCredit, 0);
  }

  get currency() {
    return this.store.getters.getCurrency;
  }

  clearForFilters() {
    this.searchFilters.date1 = "";
    this.searchFilters.date2 = "";
  }

  clearSearch() {
    this.searchFilters.filterType = "None";
  }
}
